module.exports = __webpack_public_path__ + "static/img/103440.f11a1cbe.png";